import { PageConfig } from "app/ear-training/mixing/__helpers/getPageConfig";

export const pages = {
  home: "Home",
  mixEarTraining: "Mix Ear Training",
  unsubscribe: "Unsubscribe",
  earTrainingShow: (params: PageConfig) => {
    if (params.type === "instrument") {
      return `Ear Trainings//instrument:${params.instrument}`;
    }

    if (params.type === "technique") {
      return `Ear Trainings//technique:${params.technique}`;
    }

    throw new Error("invalid params");
  },
  vocalDriller: "Vocal Driller",
  vocalDrillerMarketingPage: "Vocal Driller Marketing Page",
  notificationManager: "Notification Manager",
};
